export enum UserRoles {
  ADMIN = 'Admin',
  CASHADVANCE = 'CashAdvance',
  LOAN = 'Loan',
  SECURITIZATION = 'Securitization',
}
